import { useSingleMinigrid } from "../../../hook";
import PowerInfoView from "./PowerInfoView/PowerInfoView";


export default function PowerInfoPresenter() {
   const {singleMinigridQuery: {
    data, isLoading
   }} = useSingleMinigrid()


   if (isLoading) return <div>Loading...</div>
  return (
    <PowerInfoView 
      powerGenerator={data?.minigrid_power_generator}
      batteryCapacity={data?.minigrid_battery_capacity}
      inverter={data?.minigrid_inverter}
      power = {data?.minigrid_power}
    />
  )
}
